import WidgetFormService from '../../WidgetForm/WidgetFormService';

export default {
	props: {
		field: { type: Object },
		titleValue: { type: String },
		titleEnabled: { type: Boolean },
		placeholderValue: { type: String },
		descriptionValue: { type: String },
		placeholderEnabled: { type: Boolean },
		descriptionEnabled: { type: Boolean },
		fieldValue: { type: [Object, String, Number, Boolean, Array] },
		defaultValue: { type: [Object, String, Number, Boolean, Array] },
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	computed: {
		value: {
			get() {
				return this.getFieldValue();
			},
			set(value) {
				this.setFieldValue(value);
			},
		},
		fieldOptions: {
			get() {
				return this.fieldMetadata.options;
			},
		},
		fieldMetadata: {
			get() {
				return this.field.metadata;
			},
		},
		titleValueLocal: {
			set(value) {
				this.$emit('update:titleValue', value);
			},
			get() {
				return this.titleValue;
			},
		},
		descriptionValueLocal: {
			set(value) {
				this.$emit('update:descriptionValue', value);
			},
			get() {
				return this.descriptionValue;
			},
		},
		defaultFieldListeners() {
			const vm = this;
			return {
				'update:titleValue': (value) => {
					vm.titleValueLocal = value;
				},
				'update:descriptionValue': (value) => {
					vm.descriptionValueLocal = value;
				},
			};
		},
		fieldValidationRules() {
			const rules = [];
			if (this.fieldOptions?.required?.enabled) {
				rules.push((v) => (['', null, undefined].includes(v) ? `This field is required` : true));
			}
			return rules;
		},
		defaultFieldProps() {
			return {
				fieldValue: this.fieldValue,
				titleEnabled: this.titleEnabled,
				titleValue: this.titleValueLocal,
				descriptionEnabled: this.descriptionEnabled,
				descriptionValue: this.descriptionValueLocal,
			};
		},
		activeFormFieldCommonProps() {
			const customFieldValidation = this.customFieldValidation || [];
			const customFieldProps = this.customFieldProps || {};
			const rules = [...customFieldValidation];

			// Flag is set in widget field components, mark that we want to ignore the default validations we have.
			// Used by CredentialsSelectorField, when coming from ConfigurationField
			if (!this.ignoreDefaultValidations) {
				rules.push(...this.fieldValidationRules);
			}

			return {
				rules,
				outlined: this.outlinedInput == null ? true : this.outlinedInput,
				...customFieldProps,
			};
		},
	},
	methods: {
		setFieldValue(value, label = null) {
			this.$emit('update-value', { id: this.field.id, value });
			this.$emit('update-value-label', { id: this.field.id, label });
		},
		getFieldValue() {
			return this.fieldValue;
		},
		getOption(opt) {
			const option = this.fieldOptions[opt];
			return option ? option : { enabled: false };
		},
		focus() {
			this.$refs?.[this.fieldRef]?.focus?.();
		},
		getProcessedValue(value) {
			return WidgetFormService.processPreviousSteps(
				value,
				this.previousSteps,
				this.replaceInsertDataStringDict,
				this.configurationsMappingBlocksUUIDs
			);
		},
	},
	data() {
		return {
			fieldRef: 'widget_field_ref',
		};
	},
};
